import { filter, isNil } from 'lodash'
import { OrganizationData } from 'scenes/Dashboard/data/organizations/types'
import { DigitalPresenceType } from 'scenes/Dashboard/data/digitalPresences/types'

type GetFromOrganization = { organization: OrganizationData }

export function getAttachmentsFromOrganization({ organization }: GetFromOrganization) {
  if (isNil(organization.digitalPresence)) {
    return []
  }

  return filter(organization.digitalPresence, { type: DigitalPresenceType.documentUrl })
}

export function getSignalAssessmentsFromOrganization({ organization }: GetFromOrganization) {
  if (isNil(organization.signalAssessments)) {
    return []
  }

  return organization.signalAssessments
}
